module.exports = __webpack_public_path__ + "img/entenda-como-funciona-pedale-img.2414b194.svg";